import { Matrix3, Vector3 } from '@seddi/three';
import { computeBoundsFromGeometry, finishFrameBounds } from './styleRegion';
export const computeBounds = (() => {
    const center = new Vector3();
    const normal = new Vector3();
    const normalMatrix = new Matrix3();
    return (region, mesh) => {
        // Compute object space bounds.
        const bounds = computeBoundsFromGeometry(region, mesh.geometry);
        // Compute world space bounds.
        const matrixWorld = mesh.matrixWorld;
        center.copy(bounds.center).applyMatrix4(matrixWorld);
        bounds.center.x = center.x;
        bounds.center.y = center.y;
        bounds.center.z = center.z;
        bounds.radius *= matrixWorld.getMaxScaleOnAxis();
        normalMatrix.getNormalMatrix(matrixWorld);
        normal.copy(bounds.normal).applyNormalMatrix(normalMatrix);
        bounds.normal.x = normal.x;
        bounds.normal.y = normal.y;
        bounds.normal.z = normal.z;
        // Finish frame bounds.
        finishFrameBounds(region, bounds);
        return bounds;
    };
})();
